import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import { FormattedMessage } from 'react-intl'

const SelectLanguage = (props) => {
  const links = props.langs.map(lang =>
    <li selected={lang.selected} className="ml-4" key={lang.langKey}>
      <Link to={lang.link}>
        <FormattedMessage id={`lang-${lang.langKey}`} />
      </Link>
    </li>
  )

  return (
    <section>
      <ul className="flex">
        {links}
      </ul>
    </section>
  )
}

SelectLanguage.propTypes = {
  langs: PropTypes.array
}

export default SelectLanguage
